export default __webpack_public_path__ + "static/media/STREK.1047f17e.svg";